<template>
  <div class="home--view">
    <router-link
      :to="urlForCategory(category)"
      class="home--background"
      :key="category.id"
      v-for="category in categories"
    >
      {{ category.name }}
    </router-link>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Home',
  computed: {
    ...mapState(['categories']),
    ...mapGetters(['selection'])
  },
  methods: {
    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categoryId: category.id
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue